import { createSelector } from "@reduxjs/toolkit";

import { dictionariesSelector } from "store/selectors";

export const citiesSelector = createSelector(
  dictionariesSelector,
  ({ cities }) => {
    return {
      options: cities.items.map(({ name, id }) => ({
        label: name,
        value: id,
        key: id,
      })),
      loading: cities.loading,
    };
  }
);
